<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="table" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/SearchContainer.vue';
import TableContainer from './Table/TableContainer.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, TableContainer },
	methods: {
		Refresh(currentPage = 1, pageUnit = 30) {
			this.$refs.searchContainer.searchList(currentPage, pageUnit);
		}
	}
};
</script>

<style></style>
